import React from 'react';
import { GamesView } from 'js/components/common/GamesView';

import NgpGame from '../Game';

export default props => <GamesView Game={NgpGame} {...props} />;
